<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ fullName }}
        </p>
        <span
          v-if="currentArea"
          class="user-status"
        >Area: {{ currentArea.areaName }}</span>
      </div>
      <b-avatar
        size="40"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>
    <span v-if="areas && areas.length > 1">
      <b-dropdown-item
        v-for="(area) in areas"
        :key="area.aid"
        link-class="d-flex align-items-center"
        @click="selectArea(area.aid)"
      >
        <feather-icon
          size="16"
          :icon="!!currentArea && !!area && currentArea.aid === area.aid ? 'CheckIcon' : '' "
          class="mr-50"
        />
        <span>{{ area.areaName }}</span>
      </b-dropdown-item>
      <b-dropdown-divider />
    </span>
    <b-dropdown-item
      v-if="isUserAllowSettings"
      link-class="d-flex align-items-center"
      :to="{ name: 'settings' }"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span class="ml-50 mr-50">{{ $t('common.settings') }}</span>
    </b-dropdown-item>
    <dark-toggler />
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span class="ml-50 mr-50">{{ $t('common.logout') }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BAvatar,
  BDropdownDivider,
} from 'bootstrap-vue'
import authService from '@/vue.auth.service'
import DarkToggler from './DarkToggler.vue'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    DarkToggler,
  },
  data() {
    return {
      fullName: null,
      areas: [],
      currentArea: null,
      isUserAllowSettings: authService.isUserInRole('admin') || authService.isUserInRole('write'),
    }
  },
  async created() {
    this.fullName = await authService.getFullName()
    this.areas = await authService.getAllowedAreas()
    this.currentArea = await authService.currentArea()
  },
  methods: {
    logout() {
      authService.logout(false)
    },
    async selectArea(aid) {
      if (!this.currentArea || (this.currentArea.aid !== aid)) {
        authService.selectArea(aid)
        this.currentArea = await authService.currentArea()
        this.$root.$emit('changedArea', aid)
      }
    },
  },
}
</script>

<style>
.header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu {
  width: auto;
}
</style>
